var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle3, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadsComingSoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 196,
    viewBox: "0 0 272 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 20.4621,
    width: 76.5274,
    height: 75.2728,
    rx: 19.4455,
    transform: "rotate(-15.5082 0 20.4621)",
    fill: "url(#paint0_linear_204_3689)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 20.4621,
    width: 76.5274,
    height: 75.2728,
    rx: 19.4455,
    transform: "rotate(-15.5082 0 20.4621)",
    fill: "black",
    fillOpacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42.3468,
    y: 44.3592,
    width: 57.8988,
    height: 56.9496,
    rx: 14.712,
    transform: "rotate(-15.5082 42.3468 44.3592)",
    fill: "#A0BAB6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 112.992,
    y: 33.2295,
    width: 57.8988,
    height: 56.9496,
    rx: 14.712,
    transform: "rotate(16.3462 112.992 33.2295)",
    fill: "url(#paint1_radial_204_3689)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 112.992,
    y: 33.2295,
    width: 57.8988,
    height: 56.9496,
    rx: 14.712,
    transform: "rotate(16.3462 112.992 33.2295)",
    fill: "black",
    fillOpacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 144.277,
    y: 80.4291,
    width: 57.8988,
    height: 56.9496,
    rx: 14.712,
    fill: "url(#paint2_linear_204_3689)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 144.277,
    y: 80.4291,
    width: 57.8988,
    height: 56.9496,
    rx: 14.712,
    fill: "black",
    fillOpacity: 0.1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 185.563,
    y: 101.137,
    width: 57.8988,
    height: 56.9496,
    rx: 14.712,
    transform: "rotate(6.3364 185.563 101.137)",
    fill: "#A0BAB6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 203.494,
    y: 78.4247,
    width: 67.7922,
    height: 117.224,
    rx: 22.5974,
    fill: "url(#paint3_linear_204_3689)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 203.494,
    y: 78.4247,
    width: 67.7922,
    height: 117.224,
    rx: 22.5974,
    fill: "black",
    fillOpacity: 0.1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 210.556,
    y: 83.3678,
    width: 53.6689,
    height: 105.925,
    rx: 14.1234,
    fill: "#E6ECEB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 237.39,
    cy: 177.288,
    r: 5.64935,
    fill: "url(#paint4_linear_204_3689)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 237.39,
    cy: 177.288,
    r: 5.64935,
    fill: "black",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.989 119.247C207.044 118.72 206.662 118.248 206.135 118.192L197.945 117.326C197.725 117.302 197.529 117.462 197.505 117.681L197.463 118.079C197.463 118.079 197.463 118.079 197.463 118.079C197.463 118.079 197.463 118.079 197.463 118.079L196.555 126.667C196.499 127.194 196.881 127.666 197.408 127.722L199.317 127.924C199.844 127.979 200.316 127.597 200.372 127.07L200.859 122.458C200.915 121.931 201.388 121.549 201.915 121.605L205.732 122.009C206.259 122.064 206.731 121.682 206.787 121.155L206.989 119.247Z",
    fill: "url(#paint5_linear_204_3689)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.989 119.247C207.044 118.72 206.662 118.248 206.135 118.192L197.945 117.326C197.725 117.302 197.529 117.462 197.505 117.681L197.463 118.079C197.463 118.079 197.463 118.079 197.463 118.079C197.463 118.079 197.463 118.079 197.463 118.079L196.555 126.667C196.499 127.194 196.881 127.666 197.408 127.722L199.317 127.924C199.844 127.979 200.316 127.597 200.372 127.07L200.859 122.458C200.915 121.931 201.388 121.549 201.915 121.605L205.732 122.009C206.259 122.064 206.731 121.682 206.787 121.155L206.989 119.247Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.247 145.17C204.191 145.697 203.719 146.079 203.192 146.023L195.002 145.157C194.782 145.134 194.623 144.937 194.646 144.717L194.688 144.319C194.688 144.319 194.688 144.319 194.688 144.319C194.688 144.319 194.688 144.319 194.688 144.319L195.596 135.731C195.652 135.204 196.124 134.822 196.651 134.878L198.56 135.08C199.087 135.136 199.469 135.608 199.413 136.135L198.925 140.747C198.87 141.274 199.252 141.747 199.779 141.803L203.596 142.206C204.123 142.262 204.505 142.734 204.449 143.261L204.247 145.17Z",
    fill: "url(#paint6_linear_204_3689)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.247 145.17C204.191 145.697 203.719 146.079 203.192 146.023L195.002 145.157C194.782 145.134 194.623 144.937 194.646 144.717L194.688 144.319C194.688 144.319 194.688 144.319 194.688 144.319C194.688 144.319 194.688 144.319 194.688 144.319L195.596 135.731C195.652 135.204 196.124 134.822 196.651 134.878L198.56 135.08C199.087 135.136 199.469 135.608 199.413 136.135L198.925 140.747C198.87 141.274 199.252 141.747 199.779 141.803L203.596 142.206C204.123 142.262 204.505 142.734 204.449 143.261L204.247 145.17Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.895 120.189C215.95 119.662 216.423 119.28 216.95 119.335L224.583 120.143C225.11 120.198 225.492 120.671 225.437 121.198L225.134 124.06C225.134 124.06 225.134 124.06 225.134 124.06C225.134 124.06 225.134 124.06 225.134 124.06L224.545 129.627C224.49 130.154 224.017 130.536 223.49 130.48L221.582 130.278C221.055 130.222 220.673 129.75 220.728 129.223L221.216 124.611C221.272 124.084 220.89 123.611 220.363 123.556L216.546 123.152C216.019 123.096 215.637 122.624 215.693 122.097L215.895 120.189Z",
    fill: "url(#paint7_linear_204_3689)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.895 120.189C215.95 119.662 216.423 119.28 216.95 119.335L224.583 120.143C225.11 120.198 225.492 120.671 225.437 121.198L225.134 124.06C225.134 124.06 225.134 124.06 225.134 124.06C225.134 124.06 225.134 124.06 225.134 124.06L224.545 129.627C224.49 130.154 224.017 130.536 223.49 130.48L221.582 130.278C221.055 130.222 220.673 129.75 220.728 129.223L221.216 124.611C221.272 124.084 220.89 123.611 220.363 123.556L216.546 123.152C216.019 123.096 215.637 122.624 215.693 122.097L215.895 120.189Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.153 146.111C213.097 146.638 213.479 147.111 214.006 147.167L221.64 147.974C222.167 148.03 222.639 147.647 222.695 147.12L222.998 144.258C222.998 144.258 222.998 144.258 222.998 144.258C222.998 144.258 222.998 144.258 222.998 144.258L223.586 138.692C223.642 138.165 223.26 137.692 222.733 137.636L220.825 137.435C220.298 137.379 219.825 137.761 219.77 138.288L219.282 142.9C219.226 143.427 218.754 143.809 218.227 143.753L214.41 143.35C213.883 143.294 213.411 143.676 213.355 144.203L213.153 146.111Z",
    fill: "url(#paint8_linear_204_3689)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.153 146.111C213.097 146.638 213.479 147.111 214.006 147.167L221.64 147.974C222.167 148.03 222.639 147.647 222.695 147.12L222.998 144.258C222.998 144.258 222.998 144.258 222.998 144.258C222.998 144.258 222.998 144.258 222.998 144.258L223.586 138.692C223.642 138.165 223.26 137.692 222.733 137.636L220.825 137.435C220.298 137.379 219.825 137.761 219.77 138.288L219.282 142.9C219.226 143.427 218.754 143.809 218.227 143.753L214.41 143.35C213.883 143.294 213.411 143.676 213.355 144.203L213.153 146.111Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M259.843 151.035C259.843 149.036 259.449 147.056 258.684 145.209C257.919 143.361 256.797 141.683 255.383 140.269C253.97 138.855 252.291 137.734 250.444 136.969C248.597 136.204 246.617 135.81 244.617 135.81C242.618 135.81 240.638 136.204 238.791 136.969C236.944 137.734 235.265 138.855 233.851 140.269C232.438 141.683 231.316 143.361 230.551 145.209C229.786 147.056 229.392 149.036 229.392 151.035L244.617 151.035H259.843Z",
    fill: "url(#paint9_linear_204_3689)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M259.843 151.035C259.843 149.036 259.449 147.056 258.684 145.209C257.919 143.361 256.797 141.683 255.383 140.269C253.97 138.855 252.291 137.734 250.444 136.969C248.597 136.204 246.617 135.81 244.617 135.81C242.618 135.81 240.638 136.204 238.791 136.969C236.944 137.734 235.265 138.855 233.851 140.269C232.438 141.683 231.316 143.361 230.551 145.209C229.786 147.056 229.392 149.036 229.392 151.035L244.617 151.035H259.843Z",
    fill: "black",
    fillOpacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 244.617,
    cy: 130.735,
    r: 10.1502,
    fill: "#619D94"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.991 137.713C250.141 139.667 247.523 140.885 244.62 140.885C241.717 140.885 239.098 139.667 237.248 137.713C237.748 137.437 238.263 137.188 238.793 136.969C240.64 136.204 242.62 135.81 244.619 135.81C246.619 135.81 248.599 136.204 250.446 136.969C250.976 137.188 251.491 137.437 251.991 137.713Z",
    fill: "url(#paint10_linear_204_3689)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.991 137.713C250.141 139.667 247.523 140.885 244.62 140.885C241.717 140.885 239.098 139.667 237.248 137.713C237.748 137.437 238.263 137.188 238.793 136.969C240.64 136.204 242.62 135.81 244.619 135.81C246.619 135.81 248.599 136.204 250.446 136.969C250.976 137.188 251.491 137.437 251.991 137.713Z",
    fill: "black",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_204_3689",
    x1: 15.723,
    y1: 20.4621,
    x2: 84.311,
    y2: 98.5853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_204_3689",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.047 61.7169) rotate(46.3667) scale(39.3597 38.5079)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_204_3689",
    x1: 156.173,
    y1: 80.4291,
    x2: 208.065,
    y2: 139.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_204_3689",
    x1: 217.422,
    y1: 78.4247,
    x2: 315.737,
    y2: 142.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_204_3689",
    x1: 234.062,
    y1: 171.639,
    x2: 244.378,
    y2: 183.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_204_3689",
    x1: 199.508,
    y1: 117.491,
    x2: 207.963,
    y2: 128.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_204_3689",
    x1: 196.565,
    y1: 145.322,
    x2: 207.097,
    y2: 136.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_204_3689",
    x1: 223.577,
    y1: 120.036,
    x2: 213.045,
    y2: 128.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_204_3689",
    x1: 220.634,
    y1: 147.867,
    x2: 212.178,
    y2: 137.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_204_3689",
    x1: 235.648,
    y1: 135.81,
    x2: 246.062,
    y2: 159.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_204_3689",
    x1: 240.277,
    y1: 135.81,
    x2: 242.897,
    y2: 144.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadsComingSoon);
export default __webpack_public_path__ + "static/media/uploadsComingSoon.ed897e42e0c6a7da072be388007ac576.svg";
export { ForwardRef as ReactComponent };